import { render, staticRenderFns } from "./popular.vue?vue&type=template&id=6ec00c0e&scoped=true"
import script from "./popular.vue?vue&type=script&lang=js"
export * from "./popular.vue?vue&type=script&lang=js"
import style0 from "./popular.vue?vue&type=style&index=0&id=6ec00c0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec00c0e",
  null
  
)

export default component.exports